/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


var sections = window.theme.sections;
 
var headerExtension = {
  init: function() {
    this.on('section_load', this._promiseHeaderSlideIn.bind(this));
  },
 
  _promiseHeaderSlideIn: function() {
    //override original function
  }
};

sections.extend('header-section', headerExtension);
$(document).ready(function() {
  if( typeof(productOptions ) != "undefined" ){
    for(i=0;i<productOptions.length;i++) {
      $('.single-option-selector:eq('+ i +')')
      .filter(function() {
        return $(this).find('option').length > 1
      })
      .prepend('<option value="">Select A ' + productOptions[i][i] + '</option>')
      .val('')
      .trigger('change');
    }
  }

  // $('#video_player')[0].src = 'https://cdn.shopify.com/videos/c/o/v/a1dfb3e74d2c40e88c5b91096f5a7b1d.mp4';
  // $('#video_player')[0].load();
  // $('#video_player')[0].muted = true;
  $('#video_player')[0].play();
  
});